import { render, staticRenderFns } from "./NoVideosFoundKeywordsPage.vue?vue&type=template&id=fbb733d4&scoped=true&"
import script from "./NoVideosFoundKeywordsPage.vue?vue&type=script&lang=js&"
export * from "./NoVideosFoundKeywordsPage.vue?vue&type=script&lang=js&"
import style0 from "./NoVideosFoundKeywordsPage.vue?vue&type=style&index=0&id=fbb733d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb733d4",
  null
  
)

export default component.exports